import DragHandleIcon from "@material-ui/icons/DragHandle";
import * as MD from "@material-ui/core";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, Route } from "react-router-dom";
import { Dispatch } from "redux";
import { IApplicationState, IConnectedReduxProps } from "../Store";
import { setLocale } from "../Store/I18n/Actions";
import { Locales } from "../Store/I18n/Constants";
import { I18N, ILocaleInfos } from "../Store/I18n/Types";
import { hideDrawer, setTheme, showDrawer } from "../Store/Layout/Actions";
import { ILayoutState } from "../Store/Layout/Types";
import { logout } from "../Store/User/Actions";
import { IUserState } from "../Store/User/Types";
import { PaletteMode } from "../Themes";
import { StatisticsRepartitionContent } from "./Statistics/StatisticsRepartitionContent";
import { StatisticsEvolutionContent } from "./Statistics/StatisticsEvolutionContent";
import { StatsRepartitionDrawer } from "./Sidebar/StatsRepartitionDrawer";
import { StatsEvolutionDrawer } from "./Sidebar/StatsEvolutionDrawer";
import { setDrawerContent, setPageContent } from "../Store/Layout/Actions";
import { TypedStorage } from "../Utils/TypedStorage";
import { Config } from "../config";
import { ToggleSwitchV2 } from "../Themes/StyledElements";
import { setElectionPage } from "../Store/Elections/Actions";
import { EtudeType, IElectionsState } from "../Store/Elections/Types";

// ICONS
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import TalkLightLogo from "../Assets/talk-light-logo.png";
import TalkDarkLogo from "../Assets/talk-dark-logo.png";

import styles from "./AppBar.style";

interface IOwnState {
  localeMenuAnchor: HTMLElement | null;
  localeMenuOpen: boolean;
  userMenuAnchor: HTMLElement | null;
  userMenuOpen: boolean;
  productMenuAnchor: HTMLElement | null;
  productMenuOpen: boolean;
  theme: PaletteMode | null;
  toggle: boolean;
  statisticsAnchor: HTMLElement | null;
  statisticsOpen: boolean;
  statisticsValue: number;
}

interface IPropsFromState {
  i18n: I18N;
  layout: ILayoutState;
  localeInfos: ILocaleInfos;
  router: RouteComponentProps<{}>;
  user: IUserState;
  width: string;
  elections: IElectionsState;
}

interface IPropsFromDispatch {
  hideDrawer: typeof hideDrawer;
  logout: typeof logout;
  setLocale: typeof setLocale;
  showDrawer: typeof showDrawer;
  setTheme: typeof setTheme;
  setElectionPage: typeof setElectionPage;
  setPageContent: typeof setPageContent;
  setDrawerContent: typeof setDrawerContent;
}

type AllProps = MD.WithTheme &
  MD.WithStyles<typeof styles> &
  IPropsFromState &
  IPropsFromDispatch &
  RouteComponentProps<{}> &
  IConnectedReduxProps;

const initialState = {
  localeMenuAnchor: null,
  localeMenuOpen: false,
  userMenuAnchor: null,
  userMenuOpen: false,
  productMenuAnchor: null,
  productMenuOpen: false,
  theme: null,
  toggle: false,
  statisticsAnchor: null,
  statisticsOpen: false,
  statisticsValue: -1,
};

export class AppBarComponent extends React.Component<AllProps, IOwnState> {
  public constructor(props: AllProps) {
    super(props);
    this.state = {
      ...initialState,
      toggle: props.elections.etude === EtudeType.ELECTION ? false : true,
    };
    props.localeInfos.momentLocale === "fr"
      ? this.props.setLocale(Locales.French)
      : this.props.setLocale(Locales.English);
  }

  static getDerivedStateFromProps(props: AllProps, state: IOwnState) {
    if (state.theme === null) {
      state.theme = props.layout.theme;
    }
    return state;
  }

  componentDidUpdate(prevProps: AllProps) {
    // Redirect to dashboard if switching to Election mode while on Statistics page
    if (
      this.props.elections.isElectionChecked &&
      !prevProps.elections.isElectionChecked &&
      this.props.router.location.pathname === "/statistics"
    ) {
      this.props.history.push("/dashboard");
    }
  }

  private switchTheme() {
    const newTheme =
      this.state.theme === PaletteMode.DARK
        ? PaletteMode.LIGHT
        : PaletteMode.DARK;
    this.setState({ theme: newTheme });
    if (this.state.theme !== null) {
      this.props.setTheme(newTheme);
    }
  }

  private buildSwitchButton() {
    return (
      <MD.IconButton
        className={this.props.classes.switchTheme}
        onClick={this.switchTheme.bind(this)}
      >
        {this.state.theme === PaletteMode.DARK ? (
          <ToggleOnIcon
            style={{
              fill: this.props.theme.palette.secondary.main,
              fontSize: "xxx-large",
            }}
          />
        ) : (
          <ToggleOffIcon
            style={{
              fill: this.props.theme.palette.text.primary,
              fontSize: "xxx-large",
            }}
          />
        )}
      </MD.IconButton>
    );
  }

  private onElectionChange(checked: any) {
    this.props.setElectionPage(this.state.toggle);
    this.setState({ toggle: !this.state.toggle });
  }

  private buildElectionMenu() {
    return (
      <ToggleSwitchV2
        theme={this.props.theme}
        id="election"
        checked={
          this.props.elections.etude === EtudeType.ELECTION ? true : false
        }
        onChange={(checked: any) => this.onElectionChange(checked)}
        leftLabel={"PLURALISME"}
        rightLabel={"ELECTIONS"}
      />
    );
  }

  private handleUpdatePwd(ev: React.MouseEvent) {
    ev.preventDefault();
    ev.stopPropagation();
    const token = TypedStorage.get("userToken", "");
    const user_id = this.props.user.user_id;
    window.open(
      `${Config.UsersUrl}/new_password/?token=${token}&id=${user_id}`
    );
  }

  private handleStatisticsMenuOpen(event: React.MouseEvent<HTMLElement>) {
    const target = event.currentTarget;
    if (target instanceof HTMLElement) {
      this.setState({
        statisticsAnchor: target,
        statisticsOpen: !this.state.statisticsOpen,
      });
    }
  }

  private handleStatisticsClose(value: number) {
    this.setState({
      statisticsAnchor: null,
      statisticsOpen: false,
      statisticsValue: value,
    });
    if (value === 0) {
      this.props.setPageContent(
        <Route component={StatisticsRepartitionContent} />
      );
      this.props.setDrawerContent(<Route component={StatsRepartitionDrawer} />);
      this.props.history.push("/statistics");
      TypedStorage.set("statsPage", "statsRepartition");
    }
    if (value === 1) {
      this.props.setPageContent(
        <Route component={StatisticsEvolutionContent} />
      );
      this.props.setDrawerContent(<Route component={StatsEvolutionDrawer} />);
      this.props.history.push("/statistics");
      TypedStorage.set("statsPage", "statsEvolution");
    }
  }

  private onMenuTabChange(ev: React.ChangeEvent<{}>, value: string) {
    if (value !== "/statistics") {
      ev.preventDefault();
      if (this.state.statisticsValue !== -1) {
        this.props.setDrawerContent(null);
      }
      this.props.history.push(value);
    }
  }

  public render(): React.ReactNode {
    const { classes, i18n } = this.props;
    const pathParts = this.props.router.location.pathname.split("/");
    let currentPath = pathParts.length > 1 ? `/${pathParts[1]}` : "/";
    
    // If in Election mode and on /statistics, use /dashboard as the tab value since Statistics tab is hidden
    if (this.props.elections.isElectionChecked && currentPath === "/statistics") {
      currentPath = "/dashboard";
    }

    return (
      <MD.AppBar className={classes.appBar}>
        <MD.Toolbar className={classes.toolbar}>
          <div>
            <MD.Tooltip title={i18n._("Open / Close menu")}>
              <MD.IconButton
                className={classes.hamburger}
                onClick={this.toggleDrawer.bind(this)}
              >
                <MD.Icon color="primary">
                  <DragHandleIcon
                    style={{ fontSize: "20px", marginBottom: "3px" }}
                  />
                </MD.Icon>
              </MD.IconButton>
            </MD.Tooltip>
            <MD.Hidden xsDown={true}>
              <MD.Button href="/" variant="text" className={classes.logoStyle}>
                {this.props.layout.theme === PaletteMode.DARK ? (
                  <img height={34} src={TalkLightLogo} alt="talk-logo" />
                ) : (
                  <img height={34} src={TalkDarkLogo} alt="talk-logo" />
                )}
              </MD.Button>
              <MD.Typography className={classes.version} variant="caption">
                {Config.version}
              </MD.Typography>
            </MD.Hidden>
          </div>
          <div>
            <MD.Tabs
              className={classes.tabs}
              onChange={this.onMenuTabChange.bind(this)}
              value={currentPath}
            >
              <MD.Tab
                className={classes.tabItem}
                value={"/dashboard"}
                label={i18n._("Dashboard")}
              />
              {!this.props.elections.isElectionChecked && (
                <MD.Tab
                  color="primary"
                  className={classes.tabItem}
                  label={i18n._("Statistics")}
                  value={"/statistics"}
                  onClick={this.handleStatisticsMenuOpen.bind(this)}
                />
              )}
              <MD.Tab
                className={classes.tabItem}
                label={i18n._("Player")}
                value={"/player"}
              />
              <MD.Tab
                className={classes.tabItem}
                label={"Declarations ARCOM"}
                value={"/declarationsARCOM"}
              />
            </MD.Tabs>
            <MD.Popper
              className={classes.menuPopper}
              open={this.state.statisticsOpen}
              anchorEl={this.state.statisticsAnchor}
              id="menu-list-grow"
            >
              <MD.Paper>
                <MD.ClickAwayListener
                  onClickAway={this.handleStatisticsClose.bind(this, -1)}
                >
                  <MD.MenuList>
                    <MD.MenuItem
                      style={{
                        textAlign: "center",
                        textTransform: "capitalize",
                        backgroundColor:
                          this.state.statisticsValue === 0 ? "gray" : undefined,
                      }}
                      value={0}
                      key={0}
                      onClick={this.handleStatisticsClose.bind(this, 0)}
                    >
                      {i18n._("Repartition")}
                    </MD.MenuItem>
                    <MD.MenuItem
                      style={{
                        textAlign: "center",
                        textTransform: "capitalize",
                        backgroundColor:
                          this.state.statisticsValue === 1 ? "gray" : undefined,
                      }}
                      value={1}
                      key={1}
                      onClick={this.handleStatisticsClose.bind(this, 1)}
                    >
                      {i18n._("Evolution")}
                    </MD.MenuItem>
                  </MD.MenuList>
                </MD.ClickAwayListener>
              </MD.Paper>
            </MD.Popper>
          </div>
          <div
            id="user-menu"
            style={{
              paddingRight: 20,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "nowrap",
              gap: "4px",
            }}
          >
            {this.buildElectionMenu()}
            <MD.IconButton
              className={classes.language}
              aria-haspopup="true"
              onClick={this.handleLocaleMenuOpen.bind(this)}
              size="small"
            >
              {this.props.localeInfos.name}
              <ExpandMore />
            </MD.IconButton>
            <MD.IconButton
              aria-haspopup="true"
              className={classes.profileStyle}
              onClick={this.handleUserMenuOpen.bind(this)}
            >
              <AccountCircleIcon />
            </MD.IconButton>
            <MD.Menu
              anchorEl={this.state.userMenuAnchor}
              anchorOrigin={{ horizontal: "right", vertical: "top" }}
              className={classes.menus}
              id="menu-user"
              transformOrigin={{ horizontal: "left", vertical: "bottom" }}
              onClose={this.handleUserMenuClose.bind(this)}
              open={this.state.userMenuOpen}
            >
              <MD.Button
                className={classes.menuItems}
                component="a"
                title={this.props.i18n._("My account")}
                variant="text"
              >
                {this.props.user.username}
              </MD.Button>
              <MD.Button
                className={classes.menuItems}
                component="a"
                onClick={this.handleLogout.bind(this)}
                title={this.props.i18n._("Log out my session")}
                variant="text"
              >
                {this.props.i18n._("Logout")}
              </MD.Button>
              <MD.Button
                className={classes.menuItems}
                component="a"
                onClick={this.handleUpdatePwd.bind(this)}
                title={this.props.i18n._("Update my password")}
                variant="text"
              >
                {this.props.i18n._("Update my password")}
              </MD.Button>
            </MD.Menu>
            <MD.Menu
              anchorEl={this.state.localeMenuAnchor}
              anchorOrigin={{ horizontal: "right", vertical: "top" }}
              className={classes.menus}
              id="menu-locale"
              transformOrigin={{ horizontal: "left", vertical: "bottom" }}
              onClose={this.handleLocaleMenuClose.bind(this)}
              open={this.state.localeMenuOpen}
            >
              <MD.Button
                className={classes.menuItems}
                onClick={this.onLocaleChange.bind(this, Locales.French)}
                variant="text"
              >
                FR
                <br />
                Passer en Français
              </MD.Button>
              <MD.Button
                className={classes.menuItems}
                onClick={this.onLocaleChange.bind(this, Locales.English)}
                variant="text"
              >
                GB
                <br />
                Switch to english
              </MD.Button>
            </MD.Menu>
            {this.buildSwitchButton()}
          </div>
        </MD.Toolbar>
      </MD.AppBar>
    );
  }

  private handleUserMenuOpen(ev: React.MouseEvent<HTMLElement>) {
    ev.preventDefault();
    ev.stopPropagation();
    this.setState({
      userMenuAnchor: ev.currentTarget as HTMLElement,
      userMenuOpen: true,
    });
  }

  private handleUserMenuClose(ev: React.MouseEvent) {
    ev.preventDefault();
    ev.stopPropagation();
    this.setState({ userMenuAnchor: null, userMenuOpen: false });
  }

  private handleLocaleMenuOpen(ev: React.MouseEvent<HTMLElement>) {
    ev.preventDefault();
    ev.stopPropagation();
    this.setState({
      localeMenuAnchor: ev.currentTarget as HTMLElement,
      localeMenuOpen: true,
    });
  }

  private handleLocaleMenuClose(ev: React.MouseEvent) {
    ev.preventDefault();
    ev.stopPropagation();
    this.setState({ localeMenuAnchor: null, localeMenuOpen: false });
  }

  private handleLogout(ev: React.MouseEvent) {
    ev.preventDefault();
    ev.stopPropagation();
    this.props.logout();
    this.props.setElectionPage(false);
  }

  private toggleDrawer() {
    if (this.props.layout.showDrawer) {
      this.props.hideDrawer();
      return;
    }
    this.props.showDrawer();
  }

  private onLocaleChange(locale: Locales) {
    this.setState({ ...initialState });
    this.props.setLocale(locale);
  }
}

const mapStateToProps = (
  { i18n, layout, user, elections }: IApplicationState,
  ownProps: RouteComponentProps<{}>
) => ({
  i18n: i18n.i18n,
  layout,
  localeInfos: i18n.localeInfos,
  router: ownProps,
  user,
  elections,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  hideDrawer: () => dispatch(hideDrawer()),
  logout: () => dispatch(logout()),
  setLocale: (locale: Locales) => dispatch(setLocale(locale)),
  showDrawer: () => dispatch(showDrawer()),
  setTheme: (theme: PaletteMode) => dispatch(setTheme(theme)),
  setElectionPage: (checked: boolean) => dispatch(setElectionPage(checked)),
  setPageContent: (c: React.ReactNode) => dispatch(setPageContent(c)),
  setDrawerContent: (c: React.ReactNode) => dispatch(setDrawerContent(c)),
});

export const AppBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(MD.withWidth()(MD.withTheme(MD.withStyles(styles)(AppBarComponent))));
